/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file

==========================================================================================*/


import Vue from 'vue'
import App from './App.vue'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css' // Vuesax
Vue.use(Vuesax)

// axios
import axios from './axios.js'
Vue.prototype.$http = axios

// cachios
import cachios from './cachios.js'
Vue.prototype.$httpc = cachios

// API Calls
import './http/requests'

// Vuexy Admin Filters
import './filters/filters'

// Clipboard
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

// ACL
import acl from './acl/acl'

// Theme Configurations
import '../themeConfig.js'

// Globally Registered Components
import './globalComponents.js'

//Recaptcha V3
import {VueReCaptcha} from 'vue-recaptcha-v3'
Vue.use(VueReCaptcha, {
  siteKey: '6LerzxQaAAAAAHPNsKjCDjSctG3sYXJk0dtYyXYT',
  loaderOptions: {
    autoHideBadge: true
  }
})

// Styles: SCSS
import './assets/scss/main.scss'

//Load Script
import LoadScript from 'vue-plugin-load-script'
Vue.use(LoadScript)

// Loading Skeleton
import Skeleton from 'vue-loading-skeleton'
Vue.use(Skeleton)

// Tailwind
import '@/assets/css/main.css'

// VeeValidate
import VeeValidate from 'vee-validate'
Vue.use(VeeValidate)

// Vue Router
import router from './router'

//Vue Debounce
import vueDebounce from 'vue-debounce'
Vue.use(vueDebounce)

//Vue Transitions
import Transitions from 'vue2-transitions'
Vue.use(Transitions)

// Vuex Store
import store from './store/store'

// Vuejs - Vue wrapper for hammerjs
import {VueHammer} from 'vue2-hammer'
Vue.use(VueHammer)

//Vue Typer
import VueTyperPlugin from 'vue-typer'
Vue.use(VueTyperPlugin)

//Vue Movable
import movable from 'v-movable'
Vue.use(movable)

//Confetti
import VueConfetti from 'vue-confetti'
Vue.use(VueConfetti)

//Draggable
import VueShopifyDraggable from 'vue-shopify-draggable'
Vue.use(VueShopifyDraggable)

// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'


// Image Viewer
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 99999999999999999
  }
})
// Feather font icon
require('./assets/css/iconfont.css')


// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';


Vue.config.productionTip = false
Vue.config.ignoredElements = [/^stream/]


new Vue({
  router,
  store,
  acl,
  render: h => h(App)
}).$mount('#app')
